import PropTypes from 'prop-types';
import { Component } from 'react';
import UIList from 'UIComponents/list/UIList';
import Small from 'UIComponents/elements/Small';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ErrorList extends Component {
  render() {
    /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
    const {
      errors = []
    } = this.props;
    if (!errors.length) {
      return null;
    }
    return /*#__PURE__*/_jsx(UIList, {
      children: /*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
      errors.map((error, i) => /*#__PURE__*/_jsx(Small, {
        use: "error",
        children: error
      }, i))
    });
  }
}

/*  @ts-expect-error Sep-25-2024, 17:26UTC FixMe: Complete Migration to TypeScript  */
ErrorList.propTypes = {
  errors: PropTypes.array
};